import type { LabelCodeType } from '@/types/label-template'
import type { TemplateData } from './types'

/** Single label context when template is assigned to one code type. */
export function resolveLabelContext(template: TemplateData): LabelCodeType | null {
  const flags: LabelCodeType[] = []
  if (template.for_km) flags.push('km')
  if (template.for_ka_box) flags.push('ka_box')
  if (template.for_ka_pallet) flags.push('ka_pallet')
  if (flags.length === 1) return flags[0]

  const legacy = template.type
  if (legacy === 'km' || legacy === 'ka_box' || legacy === 'ka_pallet') return legacy
  if (flags.length > 0) return flags[0]
  return null
}

export function labelContextHint(context: LabelCodeType | null): string | null {
  switch (context) {
    case 'km':
      return 'Даты берутся с текущего КМ.'
    case 'ka_box':
      return 'Даты коробки — с первого КМ внутри этой упаковки.'
    case 'ka_pallet':
      return 'Даты паллеты — с первого КМ в коробках на паллете.'
    default:
      return null
  }
}
